import { render, staticRenderFns } from "./mymessage.vue?vue&type=template&id=01774f70&scoped=true&"
import script from "./mymessage.vue?vue&type=script&lang=js&"
export * from "./mymessage.vue?vue&type=script&lang=js&"
import style0 from "./mymessage.vue?vue&type=style&index=0&id=01774f70&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01774f70",
  null
  
)

export default component.exports